// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1XA5t","validationTips":"StatementDescriptor_validationTips__35G_-"};